// extracted by mini-css-extract-plugin
module.exports = {"container":"_2D5X90NwrcvgSKutzEOb4v","title":"_1hw2HzA-wjO8_AO7EE_x4Y appSubtitle"};